// src/js/redesignHeader.js
// Handles mobile secondary nav collapse/expand for header-redesign

export function initRedesignHeader() {
  const navToggle = document.getElementById('secondary-nav-toggle');
  const navList = document.getElementById('secondary-nav-list');
  // Not every page has the secondary nav, so bail out before touching it
  if (!navToggle || !navList) return;

  const chevron = navToggle.querySelector('.chevron-arrow');
  if (!chevron) return;

  function isDesktop() {
    return window.innerWidth >= 968;
  }

  function setNavDisplay() {
    if (isDesktop()) {
      navList.style.display = 'flex';
      navToggle.setAttribute('aria-expanded', 'true');
      chevron.classList.remove('chevron-up');
    } else {
      navList.style.display = 'none';
      navToggle.setAttribute('aria-expanded', 'false');
      chevron.classList.remove('chevron-up');
    }
  }

  function toggleNav() {
    if (isDesktop()) return;
    const isOpen = navList.style.display === 'flex';
    if (isOpen) {
      navList.style.display = 'none';
      navToggle.setAttribute('aria-expanded', 'false');
      chevron.classList.remove('chevron-up');
    } else {
      navList.style.display = 'flex';
      navToggle.setAttribute('aria-expanded', 'true');
      chevron.classList.add('chevron-up');
    }
  }

  navToggle.addEventListener('click', toggleNav);

  window.addEventListener('resize', setNavDisplay);
  setNavDisplay();

}
